import LogoParceiro from '../../components/Card/parceiro-logo.jpg';

export const confirmadas = [
  {
    parceiro: 'Agência One',
    data: new Date(),
    nome: 'Fernanda Araújo',
    empresa: 'Heineken',
    status: 'Confirmada',
    logo: LogoParceiro,
  },
  {
    parceiro: 'Agência One',
    data: new Date(),
    nome: 'Fernanda Araújo',
    empresa: 'Heineken',
    status: 'Confirmada',
    logo: LogoParceiro,
  },
  {
    parceiro: 'Agência One',
    data: new Date(),
    nome: 'Fernanda Araújo',
    empresa: 'Heineken',
    status: 'Confirmada',
    logo: LogoParceiro,
  },
  {
    parceiro: 'Agência One',
    data: new Date(),
    nome: 'Fernanda Araújo',
    empresa: 'Heineken',
    status: 'Confirmada',
    logo: LogoParceiro,
  },
  {
    parceiro: 'Agência One',
    data: new Date(),
    nome: 'Fernanda Araújo',
    empresa: 'Heineken',
    status: 'Confirmada',
    logo: LogoParceiro,
  },
  {
    parceiro: 'Agência One',
    data: new Date(),
    nome: 'Fernanda Araújo',
    empresa: 'Heineken',
    status: 'Confirmada',
    logo: LogoParceiro,
  },
];
